/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-11 10:15:22
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-get-common-method/get-video-methods.ts
 */
import { SPEC_MAP, SpecMapType } from '@/constants/video';
import useProvideBrowserInfo from '@/composable/use-provide-browser-info';
import { fixHttps } from '@/utils/no-import-meta/url';
import { ModelMetaFeed } from '@/types/model';

export default function getVideoMethods() {
  // 拿指定档位的视频source
  const getSpecUrl = function (urls: ModelMetaFeed['videoSpecUrls'], spec: SpecMapType, verify: Boolean) {
    const urlItem = urls[SPEC_MAP[spec]];
    let url = '';
    if (urlItem?.externInfo?.defaulthttpsurl) url = fixHttps(urlItem?.externInfo?.defaulthttpsurl);
    if (urlItem?.url) url = fixHttps(urlItem.url);
    if (verify) url += '&verify=1';
    return url;
  };
  const getSrcFromFeed = function (feed: ModelMetaFeed, verify: Boolean) {
    const { videoSpecUrls: urls } = feed;
    const ary = [];
    if (!urls) return ary;
    const { info } = useProvideBrowserInfo();
    if (info.isMobile) {
      // 移动端优先使用f60，其次f70
      const f60 = getSpecUrl(urls, 'f60', verify);
      if (f60) ary.push(f60);
      const f70 = getSpecUrl(urls, 'f70', verify);
      if (f70) ary.push(f70);
      // 其次使用30与20档位
      // TODO: 原始逻辑有判断如果是2g与3g情况下先使用20档，其次使用30档，暂时先不管
      const f20 = getSpecUrl(urls, 'f20', verify);
      if (f20) ary.push(f20);
      const f30 = getSpecUrl(urls, 'f30', verify);
      if (f30) ary.push(f30);
    } else {
      // pc还是用标清，因为高清分辨率太大，缩小后反而看不清 (优先使用f70，然后是f20)
      const f70 = getSpecUrl(urls, 'f70', verify);
      const f20 = getSpecUrl(urls, 'f20', verify);
      if (f70) ary.push(f70);
      if (f20) ary.push(f20);
    }
    // 前几个档位都获取不到url时使用f0
    const f0 = getSpecUrl(urls, 'f0', verify);
    if (f0) ary.push(f0);
    return ary;
  };
  const getMiniappPlayerFeed = function (feed: ModelMetaFeed) {
    const newFeed = { ...feed };
    if (newFeed.useF0) {
      newFeed.videoUrl = feed.videoUrl;
    } else {
      const videoSpecUrls = feed.videoSpecUrls || {};
      // 视频档位选择
      newFeed.videoUrl = (
        videoSpecUrls['27']
        || videoSpecUrls['25']
        || videoSpecUrls['8']
        || videoSpecUrls['2']
        || videoSpecUrls['0']
        || {}
      ).url
        || feed.videoUrl
        || '';
    }
    return newFeed;
  };

  return {
    getSpecUrl, getSrcFromFeed, getMiniappPlayerFeed,
  };
}
